import {Ticket} from "@/models/ticket";


export class TicketReadList {
	id:number;
	adminId:number;
	ticketId:number;
	timeFirstRead: Date;
	ticket?:Ticket;

	constructor(data:any) {
		this.id = data.id;
		this.ticketId = data.ticketId;
		this.adminId = data.adminId;
		this.timeFirstRead = new Date(data.timeFirstRead);
		if (data.ticket) {
			this.ticket = new Ticket(data.ticket);
		}
	}
}